'use client'

import { Carousel } from '@mantine/carousel'
import '@mantine/carousel/styles.css'
import { Modal } from '@mantine/core'
import { RiCheckLine } from '@remixicon/react'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'
import { useState } from 'react'

// @ts-ignore
import facebook from '../../../assets/Facebook.png'
// @ts-ignore
import insta from '../../../assets/Instagram.png'
// @ts-ignore
import linkedIn from '../../../assets/Linkedin.png'
// @ts-ignore
import message from '../../../assets/Message.png'
// @ts-ignore
import whatsApp from '../../../assets/Whatsapp.png'
// @ts-ignore
import twiter from '../../../assets/Xtwiter.png'
// @ts-ignore
import copyIcon from '../../../assets/copyIconBlack.png'

import styles from './ShareModal.module.css'

interface ShareModalProps {
  opened: boolean
  onClose: () => void
  referralCode: string
}

export const ShareModal = ({
  opened,
  onClose,
  referralCode,
}: ShareModalProps) => {
  const t = useTranslations('Ui.refer&earn')
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    navigator.clipboard.writeText(referralCode)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  const socialLinks = [
    {
      icon: linkedIn,
      url: 'https://www.linkedin.com/sharing/share-offsite/?url=https://your-referral-link',
    },
    {
      icon: facebook,
      url: 'https://www.facebook.com/sharer/sharer.php?u=https://your-referral-link',
    },
    {
      icon: whatsApp,
      url: 'https://wa.me/?text=https://your-referral-link',
    },
    { icon: insta, url: 'https://www.instagram.com/' },
    {
      icon: twiter,
      url: 'https://twitter.com/intent/tweet?url=https://your-referral-link',
    },
    { icon: message, url: 'sms:?body=https://your-referral-link' },
  ]

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      withCloseButton
      centered
      lockScroll={false}
      styles={{
        content: {
          width: 408,
          borderRadius: '12px',
          padding: '26px 28px',
        },
        header: { marginBottom: '16px' },
      }}
      title={<div className={styles.modalTitle}>{t('share-button')}</div>}
    >
      <div className={styles.container}>
        <Carousel
          slideSize='48px'
          slideGap='16px'
          withControls
          controlSize={22}
          className={styles.carousel}
          styles={{
            controls: {
              left: '-36px',
              right: '-36px',
            },
          }}
        >
          {socialLinks.map(({ icon, url }, i) => (
            <Carousel.Slide key={i}>
              <Link href={url} target='_blank'>
                <div className={styles.iconButton}>
                  <Image src={icon} alt='share icon' width={28} height={28} />
                </div>
              </Link>
            </Carousel.Slide>
          ))}
        </Carousel>

        <div className={styles.copyBox}>
          <span className={styles.referralText}>{referralCode}</span>

          {copied ? (
            <span className={styles.copiedText}>
              <RiCheckLine size={14} />
              {t('copied')}
            </span>
          ) : (
            <button
              type='button'
              onClick={handleCopy}
              className={styles.copyButton}
            >
              <Image src={copyIcon} alt='Copy icon' width={16} height={16} />
            </button>
          )}
        </div>
      </div>
    </Modal>
  )
}
